import { IItemCache } from '../IItemCacheObserver';
import { itemsScopeControl } from '../../controls/itemsScopeControl';

/**
 * @internal
 */
export function getItemsScope(itemCache: IItemCache, props: {} = {}): {
  itemsScopeItemKey?: string;
} {
  const itemsScopeControlHandler = itemCache.demandItemFacet(itemsScopeControl, undefined);
  return itemsScopeControl.evaluate(itemsScopeControlHandler)(itemCache, {});
}
